const integer = new Intl.NumberFormat('pt-PT', { maximumFractionDigits: 0 });
const decimal = new Intl.NumberFormat('pt-PT', { maximumFractionDigits: 1 });

/** A count, with the thousands set apart. */
export function formatCount(value: number): string {
  return integer.format(value);
}

/** Hours to one decimal place, "12,5 h". */
export function formatHours(hours: number): string {
  return `${decimal.format(hours)} h`;
}

/** Hours as they are lived, "2h 30m": for what is happening today. */
export function formatDuration(hours: number): string {
  const minutes = Math.round(hours * 60);
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  if (h === 0) return `${m}m`;
  if (m === 0) return `${h}h`;
  return `${h}h ${m}m`;
}

/** The share a part is of a whole, "42%". Zero when there is no whole. */
export function formatShare(part: number, whole: number): string {
  if (whole <= 0) return '0%';
  return `${Math.round((part / whole) * 100)}%`;
}

export type DeltaDirection = 'up' | 'down' | 'same' | 'none';

export interface Delta {
  direction: DeltaDirection;
  text: string;
}

/**
 * How a figure compares with the one before. With nothing before there is
 * nothing to compare with: a rise from zero has no percentage.
 */
export function describeDelta(current: number, previous: number): Delta {
  if (previous === 0) {
    return current === 0
      ? { direction: 'none', text: 'Sem movimento nos dois períodos' }
      : { direction: 'none', text: 'Nada no período anterior' };
  }
  if (current === previous) return { direction: 'same', text: 'Igual ao período anterior' };

  const change = Math.round(((current - previous) / previous) * 100);
  // A change too small to round to 1% is still a change.
  const shown = change === 0 ? '<1' : String(Math.abs(change));
  return current > previous
    ? { direction: 'up', text: `+${shown}% face ao período anterior` }
    : { direction: 'down', text: `−${shown}% face ao período anterior` };
}
